export function radToDegree(rad: TODOAny) {
  return rad * (180 / Math.PI)
}

export function degreeToRad(degree: TODOAny) {
  return degree * (Math.PI / 180)
}
